import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "@/assets/css/tailwind.css";
import router from "../src/router";
import store from "./store";
import VueSwal from "vue-swal";
import VueElementLoading from "vue-element-loading";
import UploadImage from "vue-upload-image";
Vue.component("upload-image", UploadImage);

Vue.use(VueSwal);
Vue.component("VueElementLoading", VueElementLoading);
import * as VueGoogleMaps from "vue2-google-maps";
import VueGeolocation from "vue-browser-geolocation";

Vue.config.productionTip = true;

Vue.use(VueGeolocation);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDG2elsulmnpojDv-khvv0VTvmsUaZA46A",
    libraries: "places"
  }
});

Vue.use(require("vue-moment"));
Vue.config.productionTip = false;

// live endpointsz
Vue.prototype.$baseUrl = "https://ekocarbonbe.herokuapp.com";
if (window.location.hostname == "localhost") {
  Vue.prototype.$baseUrl = "http://localhost:1234";
}

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount("#app");
